import { ContentType } from 'utility/Request/Api/types';
import { getCookieValue } from 'utility/Track/cookies';

export function determineContentType() {
    const cookieValue = getCookieValue('dbgbar_force_json_rpc');
    const isJsonRpc =
        cookieValue === '1' ||
        new URLSearchParams(window.location.search).has('jsonRpc');

    return isJsonRpc
        ? ContentType.Json
        : (process.env.C24_RPC_CONTENT_TYPE as ContentType) ||
              ContentType.Protobuf;
}
